import { Component } from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser';
import { OrderService } from '../../services';

@Component({
  selector: 'order-dump',
  templateUrl: './order-dump.component.html',
  styleUrls: ['./order-dump.component.scss'],
})
export class OrderDumpComponent {
  dataNumber: string;
  isBusy: boolean;

  downloadData: any;
  downloadFileName: string;

  private _order: any;
  get order(): any {
    return this._order;
  }

  set order(value: any) {
    this._order = value;

    this.downloadData = this.downloadFileName = null;
    if (value) {
      this.downloadData = this.domSanitizer.bypassSecurityTrustUrl(
        `data:text/json;charset=utf-8, ${encodeURIComponent(JSON.stringify(value, null, 4))}`,
      );
      this.downloadFileName = `order_${this.dataNumber}.json`;
    }
  }

  constructor(private service: OrderService, private domSanitizer: DomSanitizer) {}

  getDump() {
    if (!this.dataNumber) return;

    this.isBusy = true;
    this.service.getDump(this.dataNumber).then((res) => {
      this.isBusy = false;
      this.order = res;
    });
  }

  onSubmit() {
    this.getDump();
  }

  clear() {
    this.dataNumber = null;
    this.order = null;
  }
}
